export default __webpack_public_path__ + "static/media/loading-image.5ca3a7f6.svg";